"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageMechanism = void 0;
var StorageMechanism;
(function (StorageMechanism) {
    StorageMechanism["LocalStorage"] = "localStorage";
})(StorageMechanism = exports.StorageMechanism || (exports.StorageMechanism = {}));
//# sourceMappingURL=storageMechanism.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/constants/storageMechanism.js
// module id = HPcu
// module chunks = 69